// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "c01ad7a9",
    "hash": "c01ad7a9",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "c01ad7a9",
    "semverString": null,
    "version": "1.0.0"
};
/* tslint:enable */
